import Flex from '../../../components/Flex';
import { REFERENCE_LINKS } from '../../../constants';

export const linkVariants = [
  {
    value: 'Paired with icon',
    label: (
      <Flex style={{ width: '100%' }} align="center" justify="space-between">
        Paired with icon
        <Flex className="info-download-icon" gap="8px" align="center" />
      </Flex>
    ),
  },
  {
    value: 'Default',
    label: (
      <Flex style={{ width: '100%' }} align="center" justify="space-between">
        Default
        <Flex className="info-download-icon" gap="8px" align="center" />
      </Flex>
    ),
  },
];

export const dataExternalLinkGroups = [
  {
    id: 1,
    title: 'Government usability testing resources',
    cards: [
      {
        title: 'IBM Web Accessibility Checklist',
        subtitle: '[ibm.com]',
        linkUrl: REFERENCE_LINKS.ibmAccessibilityChecklist,
      },
      {
        title: 'Government usability testing resources',
        subtitle: '[digital.gov]',
        linkUrl: REFERENCE_LINKS.digitalGovUsabilityTesting,
      },
    ],
  },
];
